/**
 * Word Reveal Module — Wort-für-Wort-Einblendung
 *
 * Purpose:
 * - Blendet den Text eines [data-reveal-words]-Elements Wort für Wort ein,
 *   sobald das Panel aktiv wird. Jedes Wort blitzt kurz Magenta auf.
 * - Default-Kadenz 380 ms/Wort; überschreibbar per data-reveal-cadence="320"
 *   oder data-reveal-timings="[0,420,890,…]" (ms-Offsets, sobald echte
 *   Audio-Timestamps vorliegen — Plan-Posten M2 Stufe B).
 * - prefers-reduced-motion: alles sofort sichtbar.
 * - Einmal pro Page-Load; bei Re-Entry sind alle Wörter sofort sichtbar.
 *
 * Aktivierung: Attribut data-reveal-words auf einem Text-Element im Panel.
 * Generisch — gebaut für Nadelöhr, nutzbar für jeden Story-Text.
 * Das Highlight-Wort (.nb-hl) bleibt durchgängig hervorgehoben.
 *
 * Dependencies: keine (hört story:panel:activated direkt).
 * File: assets/js/story/story-module-word-reveal.js
 */
(function (window, document) {
  'use strict';

  var DEFAULT_CADENCE = 380;   // ms pro Wort
  var cssInjected = false;

  function injectCss() {
    if (cssInjected) return;
    cssInjected = true;
    var css =
      '.srw-word{opacity:0;}' +
      '.srw-word.is-revealed{opacity:1;transition:opacity .18s ease-out;}' +
      '.srw-word.is-revealed:not(.nb-hl){animation:srw-flash .5s ease-out;}' +
      '@keyframes srw-flash{0%{background:rgba(255,142,255,.85);}100%{background:transparent;}}' +
      '@media(prefers-reduced-motion:reduce){.srw-word{opacity:1;}' +
      '.srw-word.is-revealed{animation:none;transition:none;}}';
    var s = document.createElement('style');
    s.setAttribute('data-story-word-reveal', '');
    s.textContent = css;
    document.head.appendChild(s);
  }

  // Text in Wort-Spans zerlegen; <br> bleibt, Inline-Elemente (.nb-hl) = ein Wort.
  function tokenize(el) {
    var words = [];
    var nodes = [].slice.call(el.childNodes);
    var frag = document.createDocumentFragment();
    nodes.forEach(function (node) {
      if (node.nodeType === 3) {                       // Text-Knoten
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (part === '') return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var span = document.createElement('span');
          span.className = 'srw-word';
          span.textContent = part;
          frag.appendChild(span);
          words.push(span);
        });
      } else if (node.nodeType === 1) {                // Element-Knoten
        if (node.tagName === 'BR') { frag.appendChild(node); return; }
        node.classList.add('srw-word');                // Inline-Element = ein Wort
        frag.appendChild(node);
        words.push(node);
      }
    });
    el.innerHTML = '';
    el.appendChild(frag);
    return words;
  }

  function revealElement(el) {
    if (el._srwWords) {                                // Re-Entry — alles sichtbar
      el._srwWords.forEach(function (w) { w.classList.add('is-revealed'); });
      return;
    }
    var words = tokenize(el);
    el._srwWords = words;

    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      words.forEach(function (w) { w.classList.add('is-revealed'); });
      return;
    }

    var timings = null;
    var raw = el.getAttribute('data-reveal-timings');
    if (raw) { try { timings = JSON.parse(raw); } catch (e) { timings = null; } }
    var cadence = parseInt(el.getAttribute('data-reveal-cadence'), 10) || DEFAULT_CADENCE;

    words.forEach(function (w, i) {
      var delay = (timings && isFinite(timings[i])) ? timings[i] : i * cadence;
      setTimeout(function () { w.classList.add('is-revealed'); }, delay);
    });
  }

  function onPanelActivated(e) {
    var panel = e.detail && e.detail.panel;
    if (!panel) return;
    var els = panel.querySelectorAll('[data-reveal-words]');
    for (var i = 0; i < els.length; i++) revealElement(els[i]);
  }

  function start() {
    injectCss();
    window.addEventListener('story:panel:activated', onPanelActivated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.StoryModuleWordReveal = { revealElement: revealElement };

})(window, document);
